import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/location/locationInfo.svg'
import _imports_1 from '@/assets/location/virtual.svg'
import _imports_2 from '../../assets/chat/empty-img-default.svg'


const _withScopeId = n => (_pushScopeId("data-v-5191ab40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "locationPage" }
const _hoisted_2 = { class: "locationContent" }
const _hoisted_3 = {
  name: "first",
  lazy: true,
  class: "",
  style: {"height":"100%"}
}
const _hoisted_4 = { style: {"height":"100%"} }
const _hoisted_5 = {
  key: 0,
  class: "selectDevice"
}
const _hoisted_6 = ["infinite-scroll-disabled"]
const _hoisted_7 = {
  key: 0,
  class: "skeletonWrapper"
}
const _hoisted_8 = { class: "skeleton" }
const _hoisted_9 = { class: "skeletonItemWrapper" }
const _hoisted_10 = { class: "skTop" }
const _hoisted_11 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_12 = { class: "hoverContact" }
const _hoisted_13 = { class: "leftInfo" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "itemInfo" }
const _hoisted_17 = { class: "infoDetail" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["element-loading-text"]
const _hoisted_22 = {
  key: 0,
  class: "noMore"
}
const _hoisted_23 = {
  key: 2,
  class: "empty"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "empty-img",
  alt: ""
}, null, -1))
const _hoisted_25 = { class: "empty-text" }
const _hoisted_26 = {
  class: "rightMaps",
  style: {"width":"calc(100vw - 257px - 355px)","height":"calc(100vh - 120px)"}
}

import { ref, onMounted, nextTick, computed, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import emitter from "@/utils/eventBus";
import { getQueryParam, gaEvent } from "@/utils/format";
import { ElMessage } from "element-plus";
import { contactDemoRes } from "@/components/chat/config/chatConfig";
import { event } from "vue-gtag";
import { getLocationApi } from "@/api/devices";
import publicHeader from '@/components/publicHeader/publicHeader.vue'
import mapBox from '@/components/mapbox/map.vue'
import Tooltip from "@/components/common/tooltip.vue";
import { dateFormat, dateFormatAm } from "@/utils/format";
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css'
import markerIcon from '@/assets/location/icon.svg'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import "@/styles/_mixin.scss";
import { useRouter } from "vue-router";
import { getAddressInfo } from "@/utils/mapFun";


export default /*#__PURE__*/_defineComponent({
  __name: 'locations',
  props: {
  accessTime: {
    type: Array,
  },
  isSync: {
    type: Boolean
  }
},
  emits: ['sendlastTime'],
  setup(__props, { emit: Emits }) {

const props = __props



const store = useStore();
let router = useRouter();
const { t } = useI18n();
const isVibe = computed(() => !store.state.isVibe);

// 定义网络请求的起始时间
let startTime = ref('')
let endTime = ref('')
const showUpdateTime = ref(false)
const deviceId = computed(() => store.state.currentDeviceInfo.id);
const appId = computed(() => store.state.currentDeviceInfo.apple_id);
const deviceName = computed(() => store.state.currentDeviceInfo.name);
const showRightBox = ref(true) //是否展示时间筛选
// Tab1：地图信息的全部内容
const locationList = ref([]);
let cumulativeContactList: any = [];
const contactPageNum = ref(1); // 页码
let contactPageSize = ref(20); // 一页多少条数据
let noMoreContact = ref(false); // 是否展示没有更多数据文案
let contactGlobalLoading = ref(true);
const contactLoading = ref(false);
const disabledContactScroll = computed(
  () => contactLoading.value || noMoreContact.value
);
const lastUpdateTime = ref(0)//最后更新时间
const lcoationMap = ref([0, 0])//经纬度
const locationNameItem = ref('')//app传来的名称
const isFirst = ref(false)//是否第一次进入到页面
const leftChatActive = ref(0);
const iosList = ref([]) //ios列表
const deviceInfo = computed(() => {
  return store.state.deviceInfo;
});
const deviceType = computed(() => {
  return store.state.deviceType
})
const messageToastType = computed(() => store.state.messageToastType);
const currentAppleId = computed(() => store.state.currentAppleId)
watch(currentAppleId, (newV: any) => {
  deviceInfo.value.forEach((item: any, index: any) => {
    if (item.apple_id == newV) {
      console.log("item.apple_id:", item.apple_id);

      iosList.value = deviceInfo.value[index].devices
    }
  })
}, {
  immediate: true
})
const contactItemClick = (index: any, item: any) => {
  lcoationMap.value[0] = item.longitude
  lcoationMap.value[1] = item.latitude
  // lcoationMap.value[0] = lcoationMap.value[0] + 1
  // lcoationMap.value[1] = lcoationMap.value[1] + 1
  leftChatActive.value = index;
  locationNameItem.value = item.detail
  console.log("item:", item);
  console.log("leftChatActive:", leftChatActive.value);
  console.log("lcoationMap:", lcoationMap.value);

};

watch(deviceId, async () => {
  contactPageNum.value = 1
  locationList.value = [];
  cumulativeContactList = []
  noMoreContact.value = false
  await getLocationFun()
  gaEvent("Location_PV", {
    event_category: "Location-Tracking",
    event_label: locationList.value.length > 0 ? 'Data' : 'NoData',
  });
  if (!isVibe.value) {
    clearInterval(closeFiveM);
    if (!deviceType.value) setNewInterval()
  }
})
// watch(() => props.isSync, () => {
watch(() => [props.accessTime, props.isSync], (newValue, oldValue) => {
  console.log("监听到了:", props);
  console.log("newValue:", newValue, oldValue);
  if (newValue[1]) {
    locationList.value = [];
    cumulativeContactList = []
    noMoreContact.value = false
    getLocationFun(false, true)

    console.log("状态同步成功");
  } else if ((newValue[0] != oldValue[0]) || (newValue[2] != oldValue[2])) {
    locationList.value = [];
    cumulativeContactList = []
    noMoreContact.value = false
    console.log("newValue:", newValue[0], oldValue[0]);
    getLocationFun(false)
    console.log("时间同步成功:");
  }
  contactGlobalLoading.value = false;
}, {
  deep: true
})
// 五分钟定时更新
let closeFiveM: any
if (!deviceType.value) {
  closeFiveM = setInterval(() => {
    contactPageNum.value = 1
    locationList.value = [];
    cumulativeContactList = []
    noMoreContact.value = false
    getLocationFun()
  }, 1000 * 60 * 5);
  // 设置新的定时器

}
const setNewInterval = () => {
  closeFiveM = setInterval(() => {
    contactPageNum.value = 1
    locationList.value = [];
    cumulativeContactList = []
    noMoreContact.value = false
    getLocationFun()
  }, 1000 * 60 * 5);
}
// isFromScroll是否是无限滚动触底时触发的
const getLocationFun = async (isFromScroll: boolean = false, isSync?: boolean) => {
  // 调用接口获取聊天记录,获取一页的数据
  // console.log(isFromScroll, 'isFromScroll');
  // console.log('isFromScroll:', props.accessTime![0]);
  console.log("??????????进来辣么");

  contactGlobalLoading.value = true
  try {
    let onePageContactList: any = [];
    let params = {}
    if (!isVibe.value) {
      params = {
        device_id: deviceId.value,
        start_date: startTime.value,
        end_date: endTime.value,
        page: contactPageNum.value,
        apple_id: appId.value,
        os: deviceType.value == 1 ? 'ios' : 'android'
      }
    } else {
      console.log('demodemo');
      params = {
        device_id: deviceId.value,
        start_date: 1659283200,
        end_date: 2195740800,
        page: contactPageNum.value,
        apple_id: appId.value,
        os: deviceType.value == 1 ? 'ios' : 'android'
      }
    }
    // if (deviceType == 1) {
    //   delete params.device_id; // 删除 device_id 属性
    // }
    let res: any;
    // console.log('getLocationFun执行');
    const chatListSourceRef = computed(() => store.state.chatListSource);
    // 取消掉上一次请求
    chatListSourceRef.value &&
      chatListSourceRef.value.cancel("请勿频繁请求会话列表接口");
    res = await getLocationApi(params);
    if (res.data.code == 200) {
      console.log("lastUpdateTime:", lastUpdateTime.value);
      if (isSync) {

        cumulativeContactList = []
        noMoreContact.value = false
        if (lastUpdateTime.value == res.data.data.update_time) {
          ElMessage({
            message: t("famikeep200['Synchronization successful, no new data']"),
            type: "success",
          });
        } else {
          ElMessage({
            message: t("chat.syncSuccessed"),
            type: "success",
          });
        }
        console.log("上报同步埋点");

        gaEvent("Location_Sync", {
          event_category: "Location-Tracking",
          event_label: 'Success',
        });
      }
      lastUpdateTime.value = res.data.data.update_time
      console.log("lastUpdateTime.valuelastUpdateTime.valuelastUpdateTime.value：", lastUpdateTime.value);

      if (lastUpdateTime.value) {
        showUpdateTime.value = true
      } else {
        showUpdateTime.value = false
      }
      Emits('sendlastTime', lastUpdateTime.value)
      onePageContactList = res.data.data.locations || [];
      // console.log('contactGlobalLoading.value', contactGlobalLoading.value);

      contactGlobalLoading.value = false;
      cumulativeContactList =
        cumulativeContactList.concat(onePageContactList);
      locationList.value = cumulativeContactList;
      if (locationList.value.length > 0) {
        console.log("有进来？");
        locationNameItem.value = locationList.value[0].detail
        if (!isFromScroll) {
          lcoationMap.value[0] = cumulativeContactList[0].longitude
          lcoationMap.value[1] = cumulativeContactList[0].latitude
        }
        if (deviceType.value) {
          locationList.value.forEach((item: any, index) => {
            setTimeout(async () => {
              let res = await getAddressInfo([item.longitude, item.latitude])
              item.detail = res[0]
              console.log("getAddressInfores:", res);
            })
          })

        }
      }


      console.log("是否第一次进入：", isFirst.value);
      if (isFirst.value) {
        return new Promise((resolve, reject) => {
          // resolve(onePageContactList)
          resolve(res.data.data);
        });
        return
      }
      gaEvent("Location_PV", {
        event_category: "Location-Tracking",
        event_label: locationList.value.length > 0 ? 'Data' : 'NoData',
      });
      isFirst.value = true
      return new Promise((resolve, reject) => {
        // resolve(onePageContactList)
        resolve(res.data.data);
      });
    }
  } catch (err: any) {
    console.log(err);
    contactGlobalLoading.value = false;
    if (isSync) {
      gaEvent("Location_Sync", {
        event_category: "Location-Tracking",
        event_label: 'Fail',
      });
      ElMessage({
        message: t("chat.syncFailed"),
        type: "error",
      });
    }
    // emitter.emit('closeLoading')
    emitter.emit("closeChatLoading");

    if (err.response) {
      if (err.response.data.code == 401003) {
        console.log('401003');
        if (messageToastType.value !== 3) {
          store.commit('setMessageToastType', 4);
          store.commit('setIsExpiredLogin', true)
          store.commit('setIsShowBack', true)
        }
        if (!window.location.href.includes('home')) {
          router.push({ path: '/iosLogin' });
          store.commit('setDefaultMenu', null);
        }
      }
    }
  } finally {
    setTimeout(() => {
      store.commit("setSyncLoading", false);
    })
    // emitter.emit('closeChatLoading')
  }
  // }
};
const updateInfo = () => {
  // .value = 1
  if (isVibe.value) {
    store.commit("setSyncLoading", false);
    ElMessage.error(t("famikeep200['The demo mode does not support this feature, please bind the device first.']"));
    return
  }
  contactPageNum.value = 1
  locationList.value = [];
  cumulativeContactList = []
  noMoreContact.value = false

  getLocationFun(false, true)
}
const loadMoreContactList = () => {
  contactLoading.value = true;
  setTimeout(async () => {
    // console.log("loadMoreContactList");
    contactPageNum.value++;
    const res: any = await getLocationFun(true);
    // const total = res.total;
    console.log("res:", res);

    contactLoading.value = false;
    if (!res.locations) {
      // 如果当前列表总长度大于等于接口返回的数据总长度，则显示没有更多数据文案
      noMoreContact.value = true;
    }
  }, 100);
};
//接收到的时间
const updateHeaderDate = (value: any) => {
  console.log('-----');
  startTime.value = value[0]
  endTime.value = value[1]
  contactPageNum.value = 1
  locationList.value = [];
  cumulativeContactList = []
  noMoreContact.value = false
  getLocationFun()
  console.log('接收到的时间：', startTime.value, endTime.value);
};
//切换设备
const changeDeviceModel = async (index: any) => {
  console.log("-=-=-==", index);
  // return
  store.commit("setCurrentDeviceId", (iosList.value[index] as any).id);
  // let aaa = JSON.parse(JSON.stringify(iosList.value[index]))
  // aaa.storage_usage = '1111'
  await store.commit("setCurrentDeviceInfo", iosList.value[index]);

  // 修改菜单列表
  store.dispatch("updateMenuList", { deviceInfo: deviceInfo.value, getCurrent: true })
  // getLocationFun()
}
onMounted(async () => {
  // 首次渲染页面时，将列表中的第一项数据放进clickMailItemDetail
  contactGlobalLoading.value = false;

  // 如果是demo手动调用
  if (isVibe.value) {
    contactPageNum.value = 1
    locationList.value = []
    getLocationFun()
  }
});
onUnmounted(() => {
  clearInterval(closeFiveM);
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(publicHeader, {
      headerName: _ctx.$t('famikeep200.Geolocation'),
      showUpdateTime: showUpdateTime.value,
      headerSyncDate: lastUpdateTime.value,
      headerSelectData: [],
      onUpdateHeaderDate: updateHeaderDate,
      onUpdateInfo: updateInfo,
      showRightBox: showRightBox.value
    }, null, 8, ["headerName", "showUpdateTime", "headerSyncDate", "showRightBox"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["leftTabs", locationList.value.length > 0 ? '' : 'isNoData'])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_unref(deviceType) == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(deviceName),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(deviceName) ? (deviceName).value = $event : null)),
                    size: "large",
                    onChange: changeDeviceModel,
                    "popper-class": "lcoationSelect"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iosList.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          label: item.name,
                          value: index
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              "infinite-scroll-immediate": false,
              "infinite-scroll-disabled": _unref(disabledContactScroll),
              "infinite-scroll-distance": "1",
              style: _normalizeStyle([{"overflow-y":"auto","overflow-x":"hidden"}, { 'height': _unref(deviceType) ? '95%' : '100%' }]),
              class: "leftList"
            }, [
              (_unref(contactGlobalLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_el_skeleton, {
                      style: {"--el-skeleton-circle-size":"40px","width":"100%"},
                      loading: _unref(contactGlobalLoading),
                      animated: true,
                      count: 9
                    }, {
                      template: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_el_skeleton_item, {
                            variant: "circle",
                            style: {"margin-right":"12px"}
                          }),
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"40%"}
                              }),
                              _createVNode(_component_el_skeleton_item, {
                                variant: "text",
                                style: {"width":"40%"}
                              })
                            ]),
                            _createVNode(_component_el_skeleton_item, {
                              variant: "text",
                              style: {"width":"85%"}
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]))
                : _createCommentVNode("", true),
              (locationList.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationList.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["infoItem pointer", leftChatActive.value == index ? 'selected' : '']),
                            onClick: ($event: any) => (contactItemClick(index, item))
                          }, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", {
                                  class: "info",
                                  style: _normalizeStyle({ 'width': item.is_virtual ? '220px' : '260px' })
                                }, [
                                  _createVNode(Tooltip, {
                                    content: item.detail
                                  }, null, 8, ["content"])
                                ], 4),
                                (item.is_virtual)
                                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                      key: 0,
                                      "popper-class": "custom-tooltip",
                                      content: _ctx.$t('famikeep200.When obtaining this location'),
                                      placement: "bottom-start"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_18
                                      ]),
                                      _: 1
                                    }, 8, ["content"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", null, [
                                (_unref(isVibe))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_unref(dateFormatAm)(item.date, "YYYY-MM-DD HH:mm:ss")), 1))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_unref(dateFormat)(item.date, "YYYY-MM-DD HH:mm:ss")), 1))
                              ])
                            ])
                          ], 10, _hoisted_14))
                        }), 256))
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      "element-loading-text": _ctx.$t('chat.loadingText'),
                      style: _normalizeStyle({ 'margin-top': contactLoading.value ? '40px' : '10px' })
                    }, null, 12, _hoisted_21), [
                      [_directive_loading, contactLoading.value]
                    ]),
                    (_unref(noMoreContact))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t("chat.noMoreText")), 1))
                      : _createCommentVNode("", true)
                  ]))
                : (!_unref(contactGlobalLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("chat.noInfoText")), 1)
                    ]))
                  : _createCommentVNode("", true)
            ], 12, _hoisted_6)), [
              [_directive_infinite_scroll, loadMoreContactList]
            ])
          ])
        ])
      ], 2),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(mapBox, {
          lcoationMap: lcoationMap.value,
          functionPage: 'location',
          locationNameItem: locationNameItem.value
        }, null, 8, ["lcoationMap", "locationNameItem"])
      ])
    ])
  ]))
}
}

})